<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    :before-close="closeModal">


    <el-tabs v-model="activeTab" @tab-click="handleClick">

      <el-tab-pane :label="(mode=='Edit'||mode=='Create')?'':'New'" name="Edit">

        <fg-input label="Card Provider">
          <el-select class="removeReadonly" v-model="paymentCard.paymentCardProviderId" filterable placeholder="Select">
            <el-option
              v-for="provider in $store.getters.paymentCardProviders"
              :key="provider.id"
              :label="provider && provider.profile ? provider.profile.companyName : '-'"
              :value="provider.id">
            </el-option>
          </el-select>
        </fg-input>

        <fg-input type="text"
                  label="ID"
                  placeholder="card ID"
                  v-model="paymentCard.id"
                  @keyup.enter="confirm()"/>

        <fg-input label="Expiration Date">
          <el-date-picker v-model="dateExpiration"
                          type="date"
                          placeholder="Expiration date"/>
        </fg-input>
        
        <!-- <l-checkbox v-model="hot" @keyup.enter="confirm()">Hot Lead</l-checkbox> -->
      </el-tab-pane>


      <el-tab-pane v-if="false" label="Received" name="Other">
      </el-tab-pane>

    </el-tabs>

    <span slot="footer" class="dialog-footer">
      <button class="btn" @click="closeModal()">Cancel</button>&nbsp;
      <button class="btn btn-success" :disabled="activeTab == 'Received' && $store.getters.selectedObjects.length < 1" @click="confirm()">{{buttonLabel}}</button>
    </span>
  </el-dialog>
</template>

<script>
import { PaymentCard } from 'src/classes/datamodel.js'
import { DatePicker } from 'element-ui'
import utils from '../../utils.js'
export default {
  components: {
    [DatePicker.name]: DatePicker
  },
  name: 'Payment-Card-Modal',
  data () {
    return {
      selectedTab: '',
      closing: false, // without this, the tab changes every time the modal is opened in Close/Lost mode
      // dateExpiration: ''
    }
  },
  computed: {
    mode () {
      return this.$store.getters.modal.mode
    },
    title () {
      return this.mode + ' Payment Card' // ADD 's' when multiple leads selected
    },
    visible () {
      return this.$store.getters.modal.current == 'Payment Card'
    },
    paymentCard () {
      if (typeof this.$store.getters.modal.object == 'object' && this.$store.getters.modal.object.constructor.name == 'PaymentCard') { // TODO: does this work when minimized??
        return this.$store.getters.modal.object || {}
      }
      else {
        return new PaymentCard()
      }
    },
    dateExpiration: {
      get () {
        console.log('get() dateExpiration: ', utils.dateToString(this.paymentCard.dateExpiration))
        if (!this.paymentCard.dateExpiration || typeof this.paymentCard.dateExpiration != 'object'
                                             || this.paymentCard.dateExpiration.constructor.name != 'Date'
                                             || !this.paymentCard.dateExpiration.getTime()) {
          return undefined
        }
        else {
          return utils.dateToString(this.paymentCard.dateExpiration)
        }
      },
      set (date) {
        console.log('date = ', date)
        this.paymentCard.dateExpiration = new Date(date)
      }
    },
    buttonLabel () {
      switch (this.mode) {
        case 'Create':
          return 'Create'
        case 'Edit':
          return 'Save'
        default:
          return 'Save'
      }
    },
    activeTab: { // TODO (?): WHEN CLOSING MODAL, MESSES UP THE ACTIVATE TAB FOR NEXT OPEN_MODAL
      get () {
        if (this.selectedTab) {
          return this.selectedTab
        }
        else {
          return this.showReceivedTab ? 'Received' : 'Edit'
        }
      },
      set (tab) {
        if (!this.closing) {
          this.selectedTab = tab
        }
      }
    },
  },
  methods: {
    closeModal () {
      this.closing = true
      if (this.$store.getters.selectedObjectsJson) {
        this.$store.commit('STOP_SELECT_OBJECTS')
      }
      
      this.$store.dispatch('closeModal').then(function() {
        if (this) {
          this.closing = false
          this.selectedTab = ''
        }
      })
    },
    async confirm () {
      let action = ''
      let obj = null
      switch (this.mode) {
        case 'Create':
          // this.paymentCard.affiliateAccountId = this.$store.getters.affiliatesJson[this.affiliateId].affiliateAccountId
          action = 'createPaymentCard'
          obj = new PaymentCard(this.paymentCard)
          break
        case 'Edit':
          // this.paymentCard.affiliateAccountId = this.$store.getters.affiliatesJson[this.affiliateId].affiliateAccountId
          action = 'updatePaymentCard'
          obj = new PaymentCard(this.paymentCard)
          break
        default:
          console.log('PaymentCardModal > confirm(): unplanned mode')
          break
      }
      
      const res = await this.$store.dispatch(action, obj)
      // const errorMessage = !res || (res && res.errors  && res.errors.length > 0) ? res.errors.toString() : 'Error'
      if (res) {
        if (res.errors) {
          if (!res.errors[0] || typeof res.errors[0] != 'string' || !res.errors[0].toLowerCase().includes('session')) {
            this.$notify({ errorMessage: res.errors[0] })
          }
        }
        else {
          this.$notify({ successMessage: 'Saved!'})
          this.$store.dispatch('fetchBaseData')
          this.closeModal()
        }
      }
      else {
        this.$notify({ errorMessage: 'Something went wrong...'})
      }
    },
    handleClick (tab, event) {
      console.log('tab.name = ', tab.name)
      // console.log('event = ', event)
      this.selectedTab = tab.name
    }
  },
  watch: {
    visible: function (elem) {
      if (this.visible) {
        // console.log('this.$refs.tofocus.$el.children = ', this.$refs.tofocus.$el.children)
        // doesn't work without the timeout..
        // setTimeout(() => this.$refs.tofocus.$el.children[0].focus(), 500)
        // this.$refs.tofocus.$el.children[0].focus()
      }
    }
  }
}
</script>

<style>

</style>